import { useUser } from "./UserProvider";
import AddIcon from '@mui/icons-material/Add';
import NotesIcon from '@mui/icons-material/Notes';
import { Button } from "@mui/material";
import SettingsIcon from '@mui/icons-material/Settings';
import { useNavigate } from "react-router-dom";
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import EditProfileDialog from "./EditProfileDialog";
import { useState } from "react";

export function Sidebar({selected}) {
    return (
        <div style={{
            borderRight: "solid 1px #f5f5f5",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            height: "100vh",
            width: 200
        }}>
            <div>
                <Profile />
                <Write isSelected={selected === "write"}/>
                <Inspiration isSelected={selected === "search"}/>
                <ContentCalendar isSelected={selected === "content-calendar"}/>
            </div>
            <div>
                <Settings isSelected={selected === "settings"}/>
            </div>
        </div>
    )
}
function Profile() {
    const {userInfo, setUserInfo} = useUser();
    const [showEditProfileDialog, setShowEditProfileDialog] = useState(false);
    
    return (
        
        <div style={{
            display: "flex",
            width: "100%",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "start",
            gap: "10px",
            padding: "10px",

            borderBottom: "1px solid #eeeeee",
            
        }}>
            <img src={userInfo?.info?.profile_pic_cropped || "/images/avatar.jpg"} alt="Profile" style={{
                width: "40px",
                height: "40px",
                borderRadius: "50%",
                objectFit: "cover",
            }} onClick={() => setShowEditProfileDialog("profile")}/>
            <div>
                <div style={{
                    fontSize: "0.9rem",
                    color: "rgb(58 58 58)",
                }}>{userInfo?.info?.name || "Your Name"}</div>
                <div style={{
                    fontSize: "0.8rem",
                    color: "#606060",
                }}>{userInfo?.info?.description || "Your Description"}</div>
            </div>

            <EditProfileDialog smallScreen={false} userInfo={userInfo} setUserInfo={setUserInfo} dialog={showEditProfileDialog} onClose={() => setShowEditProfileDialog(false)} onSave={(data) => console.log(data)} user={userInfo} setDialog={setShowEditProfileDialog}/>
        </div>
    
    )
}

const iconAndTitleContainer = {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "start",
    gap: "10px",
    padding: "10px 20px",
    cursor: "pointer",

    textTransform: "none",
    color: "rgb(58 58 58)",
    width: "100%",
    borderRadius: "0px",
    border: "none",
    backgroundColor: "transparent",
}
const iconAndTitleContainerPressedSx = {
    '&:active': {
        backgroundColor: '#eeeeee !important', // custom pressed color
    }
}

function Write({isSelected}) {
    const navigate = useNavigate();
    return (
        <Button disableRipple style={{
            ...iconAndTitleContainer,
            backgroundColor: isSelected ? "#eeeeee" : "transparent",
        }} sx={iconAndTitleContainerPressedSx} onClick={() => {
            navigate("/chat");
        }}>
            <AddIcon />
            <div>Write</div>
        </Button>
    )
}
function ContentCalendar({isSelected}) {
    const navigate = useNavigate();
    return (
        <Button disableRipple style={{
            ...iconAndTitleContainer,
            backgroundColor: isSelected ? "#eeeeee" : "transparent",
        }} sx={iconAndTitleContainerPressedSx} onClick={() => {
            navigate("/content-calendar");
        }}>
            <CalendarMonthIcon />
            <div>Calendar</div>
        </Button>
    )
}


function Inspiration({isSelected}) {
    const navigate = useNavigate();
    return (
        <Button disableRipple style={{
            ...iconAndTitleContainer,
            backgroundColor: isSelected ? "#eeeeee" : "transparent",
        }} sx={iconAndTitleContainerPressedSx} onClick={() => {
            navigate("/search");
        }}>
            <NotesIcon />
            <div>Inspiration</div>
        </Button>
    )
}

function Settings({isSelected}) {
    const navigate = useNavigate();

    return (
        <Button disableRipple style={{
            ...iconAndTitleContainer,
            backgroundColor: isSelected ? "#eeeeee" : "transparent",
        }} sx={iconAndTitleContainerPressedSx} onClick={() => {
            navigate("/settings");
        }}>
            <SettingsIcon />
            <div>Settings</div>
        </Button>
    )
}